import baseFeedbackMessages from "./FeedbackMessages.en";
import { translateResults } from "../i18n/translate";

const lang = "ja";
const t = (text) => translateResults(lang, text);

const feedbackMessages = baseFeedbackMessages.map((f) => ({
  ...f,
  message: t(f.message),
  actions: Array.isArray(f.actions)
    ? f.actions.map((a) => ({
        ...a,
        text: t(a.text),
        label: t(a.label),
      }))
    : [],
}));

export default feedbackMessages;

